import React from 'react';
import Transporte from '../paquetes-detalle/detalle-carga-manual/paquete-detalle-transporte/paquete-detalle-transporte';
import PanelBasico from '../paquetes-detalle/panel-basico/panel-basico';
import Servicios from '../paquetes-detalle/detalle-carga-manual/servicios-incluidos/servicios-incluidos';
import Hoteles from '../paquetes-detalle/detalle-carga-manual/paquete-detalle-hoteles/paquete-detalle-hoteles';
import './detalle.css';
import SeccionConTitulo from '../paquetes-detalle/seccion-detalle/seccion-con-titulo';

const DetalleCargaManual = (props) => {

  return (
    <span className='confirmacion-pago'>
      {props.paquete.salidas[0].transporte != null ? (
        <SeccionConTitulo titulo='Áereos'>
          <Transporte
            transporte={props.paquete.salidas[0].transporte}
          />
        </SeccionConTitulo>
      )
        : ''}
      {props.paquete.salidas[0].servicios != null ? (
        <SeccionConTitulo titulo='Servicios Incluidos'>
          <Servicios
            descripcion={props.paquete.salidas[0].servicios}
            iconos={props.paquete.salidas[0].tipoServicios}
          />
        </SeccionConTitulo>
      )
        : ''}
      {props.paquete.salidas[0].hoteles != null ? (
        <SeccionConTitulo>
          <Hoteles
            destinos={props.paquete.salidas[0].destinosHoteles}
            hoteles={props.paquete.salidas[0].hoteles}
          />
        </SeccionConTitulo>
      )
        : ''}
      {props.paquete.salidas[0].observaciones != null ? (
        <SeccionConTitulo titulo='Descripción'>
          <PanelBasico
            titulo='Observaciones'
            contenido={props.paquete.salidas[0].observaciones[0]}
          />
          <PanelBasico
            titulo='No incluye'
            contenido={props.paquete.salidas[0].noIncluye}
          />
          <PanelBasico
            titulo='Política de cancelación'
            contenido={props.paquete.politicaCancelacion[0].descripcion}
          />
        </SeccionConTitulo>
      )
        : ''}
    </span>
  );
};

export default DetalleCargaManual;
